import React, { useState } from "react";

import useTheme from "../../hooks/useTheme";
import { AppLinkedText, AppOutlineButton, AppPrimaryButton } from "../UI/CustomButtons";
import { AppColumn, AppRow } from "../UI/Layouts"
import { SizedBox } from "../UI/Sizes";
import { withOpacity } from '../../utils/helperFunctions';
import AppText from "../UI/Texts/AppTexts";
import { Card, Dropdown, Icon } from "semantic-ui-react";
import { useSelector } from "react-redux";
import './UploadFile.css'
import { isoDate, openFileInNewWindow, openLocalFileInNewWindow } from "../../utils/helperFunctions";
import { t } from "i18next";
import { CANDIDATE_DOCUMENT_IDS, getDocumentNameType } from "../../utils/Constants/documentIDs";

export const UploadFile = ({ id = 'fileInput', onFileChange, title, serverMedia, isLoading, createdAt = Date.now() }) => {
    const theme = useTheme();
    const [localFileData, setFileName] = useState(null);

    const hasFileData = localFileData != null || (serverMedia != null || serverMedia != undefined);

    const handleFileChange = (event) => {
        const file = event.target.files[0];

        if (file) {
            setFileName(file);
            onFileChange(file);
        }
    };

    const handleOpenFile = () => {
        if (serverMedia) {
            openFileInNewWindow(serverMedia.fileLink)
        } else {
            openLocalFileInNewWindow(localFileData)
        }
    };


    const handleClick = () => {
        document.getElementById(id).click();
    };

    const newFileName = localFileData?.name ?? serverMedia?.fileName;
    const date = isoDate({ dateString: createdAt, removeTime: true })

    const hasData = localFileData != null || serverMedia != null;

    return (
        <AppColumn>
            {hasData && <AppColumn>
                <AppRow>
                    <AppText.Footnote>{title}</AppText.Footnote>
                    <SizedBox width={theme.spacing.elementPaddingSmall} />
                    <AppLinkedText
                        onClick={handleClick}
                        color={theme.primaryColor}
                        text={"ändra"}
                    />
                </AppRow>
                <SizedBox height={theme.spacing.elementPaddingSmall} />
            </AppColumn>}
            <Card
                fluid
                style={{
                    marginTop: '0px',
                    paddingTop: theme.spacing.elementPaddingSmall,
                    paddingLeft: theme.spacing.elementPadding,
                    paddingBottom: theme.spacing.elementPaddingSmall,
                    paddingRight: theme.spacing.elementPaddingSmall,
                    borderRadius: theme.radius.small,
                    boxShadow: "0 0px 0px rgba(0, 0, 0, 0.0)",
                    border: `1px solid ${withOpacity(theme.colors.grey, "0.6")}`,
                }}
            >
                <AppRow
                    mainAxisAlignment={"space-between"}
                    crossAxisAlignment={"center"}
                >
                    <AppRow crossAxisAlignment={"center"} style={{
                        width: '100%',
                        fontWeight: "bold",
                        fontSize: "16px",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        marginRight: theme.spacing.elementPaddingSmall,
                    }}>
                        <Icon
                            name="file outline"
                            style={{
                                fontSize: "18px",
                                color: newFileName ? theme.colors.dark : theme.colors.defaultText,
                            }}
                        />
                        <SizedBox width={theme.spacing.elementPaddingSmall} />
                        <AppText.Caption color={newFileName ? theme.colors.dark : theme.colors.defaultText}
                            cursor='pointer'
                            onClick={handleOpenFile}
                        >

                            {hasFileData && `${date} |`}   {newFileName || title}
                        </AppText.Caption>
                        <SizedBox width={theme.spacing.elementPaddingSmall} />
                    </AppRow>
                    <input
                        id={id}
                        type="file"
                        accept=".pdf,.doc,.docx"
                        style={{
                            borderRadius: "0px",
                            display: "none",
                        }}
                        onChange={handleFileChange}
                    />
                    {hasFileData ? <AppPrimaryButton
                        size='small'
                        onClick={handleOpenFile}
                        loading={isLoading}
                        style={{
                            color: theme.primaryColor,
                            borderRadius: theme.radius.small,
                        }}
                    >
                        {"Visa"}
                    </AppPrimaryButton> : <AppOutlineButton
                        size='small'
                        onClick={handleClick}
                        loading={isLoading}
                        style={{
                            color: theme.primaryColor,
                            borderRadius: theme.radius.small,
                        }}
                    >
                        {"Välj"}
                    </AppOutlineButton>}

                </AppRow>
            </Card>
        </AppColumn>
    );
};




export const SelectOrUploadFile = ({
    id = 'fileInput',
    onFileChange,
    title,
    initialFile,
    serverMedia,
    isLoading,
    type,
}) => {
    const theme = useTheme();
    const { userApplicationDocuments } = useSelector((state) => state.auth);

    const [localFileName, setFileName] = useState(getFileNameFromLocalFile(initialFile));


    function getFileNameFromLocalFile(file) {
        return file?.fileName ?? file?.name ?? null;
    }

    const handleFileChange = (event) => {
        const file = event.target.files[0];

        if (file) {
            setFileName(getFileNameFromLocalFile(file));
            onFileChange(file, null);
        }
    };

    const handleClick = () => {
        document.getElementById(id).click();
    };


    const onSelectFile = (fileName, serverMediaFile) => {
        setFileName(fileName)
        onFileChange(null, serverMediaFile);
    };


    const selectedAt = serverMedia?.createdAt;

    const newFileName = (() => {
        const name = localFileName ?? serverMedia?.fileName

        if (localFileName) {
            if (type) {
                const typeName = getDocumentNameType(type);
                return `${typeName} | ${name}`
            }

            return name;
        }

        return name;
    })()




    const userDocuments = (userApplicationDocuments ?? []).filter((doc) =>
        CANDIDATE_DOCUMENT_IDS.includes(doc.type ?? doc.fileData?.type) &&
        CANDIDATE_DOCUMENT_IDS.includes(doc.fileData?.type ?? doc.type) &&
        (!type || doc.fileData?.type === type));


    const hasFiles = userDocuments.length > 0

    return (
        <AppColumn>

            {hasFiles ?
                (<AppColumn crossAxisAlignment={'end'}>
                    <Dropdown
                        placeholder={<AppRow crossAxisAlignment={'center'} style={{ minWidth: 0 }}>
                            <Icon
                                name={newFileName ? "check circle" : "file outline"}
                                style={{
                                    paddingTop: '2px',
                                    fontSize: "18px",
                                    color: newFileName ? theme.colors.green : theme.colors.defaultText,
                                }}
                            />
                            <AppColumn style={{ minWidth: 0 }}>
                                <AppText.Caption
                                    color={newFileName ? theme.colors.dark : theme.colors.defaultText}
                                    fontWeight={newFileName && 600}
                                    margin={{ marginBottom: "0px" }}
                                    style={{
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                    }}
                                >
                                    {newFileName ?? title}
                                </AppText.Caption>
                                {newFileName && (
                                    <AppText.Footnote color={theme.colors.grey}>
                                        {selectedAt
                                            ? `${t("selected_for_application")} · ${isoDate({ dateString: selectedAt, removeTime: true })}`
                                            : t("selected_for_application")}
                                    </AppText.Footnote>
                                )}
                            </AppColumn>
                        </AppRow>}
                        fluid
                        selection
                        closeOnEscape
                        style={{
                            paddingLeft: theme.spacing.elementPadding,
                            paddingRight: theme.spacing.elementPadding,
                            paddingTop: '1rem',
                            paddingBottom: '1rem',
                            borderRadius: theme.radius.small,
                            boxShadow: "0 0px 0px rgba(0, 0, 0, 0.0)",
                            border: `1px solid ${withOpacity(theme.colors.grey, "0.6")}`,
                        }}
                        className="custom-dropdown"
                    >
                        <Dropdown.Menu>
                            {userDocuments.map((document) => {
                                return <Dropdown.Item
                                    key={document.id}
                                    value={document.id}
                                    text={<AppRow>
                                        <Icon
                                            name="file outline"
                                            style={{
                                                paddingTop: '4px',
                                                fontSize: "18px",
                                                color: newFileName ? theme.colors.dark : theme.colors.defaultText,
                                            }}
                                        />
                                        <SizedBox width={theme.spacing.elementPaddingSmall} />
                                        <AppText.Caption>
                                            {`${isoDate({ dateString: document.createdAt, removeTime: true })} | ${document.fileData?.fileName ?? `${document.id}.pdf`}`}
                                        </AppText.Caption>
                                    </AppRow>}
                                    onClick={() => onSelectFile(document.fileData?.fileName ?? `${document.id}.pdf`, document.fileData)}
                                />
                            })}
                        </Dropdown.Menu>

                    </Dropdown>

                    <input
                        id={id}
                        type="file"
                        accept=".pdf,.doc,.docx,.png,.jpg,.jpeg"
                        style={{
                            borderRadius: "0px",
                            display: "none",
                        }}
                        onChange={handleFileChange}
                    />
                    
                    <SizedBox height={theme.spacing.elementPaddingSmall} />

                    <AppRow crossAxisAlignment={'center'} >
                        <Icon
                            name={newFileName ? "exchange" : "plus"}
                            style={{
                                fontSize: "14px",
                                color: theme.primaryColor,
                            }}
                        />
                        <SizedBox width={'0.25rem'} />
                        <AppLinkedText
                            text={newFileName ? t("replace_file") : t("upload")}
                            color={theme.primaryColor}
                            onClick={handleClick}
                            underline
                        />
                    <SizedBox width={theme.spacing.elementPadding} />
                    </AppRow>
                </AppColumn>)

                : <Card
                    fluid
                    style={{
                        paddingTop: theme.spacing.elementPaddingSmall,
                        paddingLeft: theme.spacing.elementPadding,
                        paddingBottom: theme.spacing.elementPaddingSmall,
                        paddingRight: theme.spacing.elementPaddingSmall,
                        borderRadius: theme.radius.small,
                        boxShadow: "0 0px 0px rgba(0, 0, 0, 0.0)",
                        border: `1px solid ${withOpacity(theme.colors.grey, "0.6")}`,
                    }}
                >
                    <AppRow
                        mainAxisAlignment={"space-between"}
                        crossAxisAlignment={"center"}
                    >
                        <AppRow crossAxisAlignment={"center"} style={{
                            width: '100%',
                            fontWeight: "bold",
                            fontSize: "16px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            marginRight: theme.spacing.elementPaddingSmall,
                        }}>
                            <Icon
                                name={newFileName ? "check circle" : "file outline"}
                                style={{
                                    fontSize: "18px",
                                    color: newFileName ? theme.colors.green : theme.colors.defaultText,
                                }}
                            />
                            <SizedBox width={theme.spacing.elementPaddingSmall} />
                            <AppColumn style={{ minWidth: 0 }}>
                                <AppText.Caption
                                    color={newFileName ? theme.colors.dark : theme.colors.defaultText}
                                    fontWeight={newFileName && 800}
                                    style={{
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                    }}
                                >
                                    {newFileName ?? title}
                                </AppText.Caption>
                                {newFileName && (
                                    <AppText.Footnote color={theme.colors.grey}>
                                        {selectedAt
                                            ? `${t("selected_for_application")} · ${isoDate({ dateString: selectedAt, removeTime: true })}`
                                            : t("selected_for_application")}
                                    </AppText.Footnote>
                                )}
                            </AppColumn>
                            <SizedBox width={theme.spacing.elementPaddingSmall} />
                        </AppRow>
                        <input
                            id={id}
                            type="file"
                            accept=".pdf,.doc,.docx,.png,.jpg,.jpeg"
                            style={{
                                borderRadius: "0px",
                                display: "none",
                            }}
                            onChange={handleFileChange}
                        />
                        <AppOutlineButton
                            size='small'
                            onClick={handleClick}
                            loading={isLoading}
                            style={{
                                color: theme.primaryColor,
                                borderRadius: theme.radius.small,
                            }}
                        >
                            <AppRow>
                                <Icon
                                    name={newFileName ? "exchange" : "plus"}
                                    style={{
                                        fontSize: "14px",
                                        color: theme.primaryColor,
                                    }}
                                />
                                <SizedBox width={'0.25rem'} />
                                {newFileName ? t("replace_file") : t('upload')}
                            </AppRow>
                        </AppOutlineButton>
                    </AppRow>
                </Card>}


        </AppColumn>
    );
};
